import BackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

import useContrastTextColor from 'reservations/brand/hooks/useContrastTextColor';

export type DrawerContentProps = {
  headerText: string;
  subheaderText?: string;
  handleBack?: () => void;
  footer?: string;
  dataTestId?: string;
};

export const BaseDrawerContent = ({
  handleBack,
  headerText,
  subheaderText,
  footer,
  dataTestId,
  children
}: React.PropsWithChildren<DrawerContentProps>) => (
  <Box
    sx={{
      height: '100%',
      padding: '0 32px 24px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '24px'
    }}
  >
    <Box>
      <Box
        sx={{
          height: '4.375rem',
          display: 'grid'
        }}
      >
        {handleBack && <BackButton onClick={handleBack} />}
      </Box>
      <Typography variant="h2" data-testid={dataTestId}>
        {headerText}
      </Typography>
      {subheaderText && (
        <Typography marginTop="1.375rem">{subheaderText}</Typography>
      )}
      <Box mt="24px">{children}</Box>
      <Box
        sx={{
          marginTop: '2rem',
          marginBottom: '6rem'
        }}
      >
        {footer && (
          <Box>
            <Typography variant="caption" data-testid="footer">
              {footer}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  </Box>
);

type BackButtonProps = {
  onClick: () => void;
};

const BackButton = ({ onClick }: BackButtonProps) => {
  const contrastColor = useContrastTextColor();
  return (
    <Box mt="26px">
      <IconButton
        data-testid="base-drawer-back-button"
        onClick={onClick}
        aria-label="Back"
        sx={{ padding: 0 }}
      >
        <BackIcon sx={{ color: alpha(contrastColor, 0.8) }} />
      </IconButton>
    </Box>
  );
};
